//アプリ情報読込み
var lists = [];
var optionlist = ["裄丈修理（ジャージ用）オプション"];
var displayCount = 0;

//ドロップダウンの備考メッセージ
var dropDownMessage ="※お洗濯後の縮みを考慮して1.0cm長くご指定いただくことをお勧めしています。";
var dropDownCount = 0;
var dropDownCountLimit = 0;

//チェックボックスの備考メッセージ
var checkBoxMessage ="※同意するにチェックをしてカートに入れるを押してください。";
var checkBoxCount = 0;
var checkBoxCountLimit = 0;

// サイズ追加の際にはここに追加
var replaceBoldSizeData = {
  "37":83, "38":84, "39":85, "40":86, "41":87, "42":88,
  "37-Long":86.5, "38-Long":87.5, "39-Long":89, "40-Long":90, "41-Long":90, 
  "S": 85, "M": 87, "L": 87, "LL": 87
};

//標準サイズ
var defaultSize = 0;


//カスタムオーダールール呼び出し
var loadRulesInterval = setInterval(() => {
  window.customorderLoadRules(function () {
    window.GroovyCustomOrder.rules.forEach(function (rule) {

      if (rule != null) {
        if(optionlist.indexOf(rule.name) !== -1) {
          rule.data.forEach(function (ru) {
            lists.push(ru);
          })
        }
      }
    });

  });
  if (lists.length > 0) {
    clearInterval(loadRulesInterval);
    createSorceCode(lists);
  }
}, 2500)

//商品ページへオプションの埋め込み
function createSorceCode(optionList) {
  displayCount++;
  //各要素のカウント
  dropDownCountLimit = optionList.filter(n => n.type === 'select').length;
  checkBoxCountLimit = optionList.filter(n => n.type === 'checkbox').length;

  defaultSize = getSize();
  
  if(displayCount === 1){
    var html = `
      <input type="hidden" name="properties[_CUSTOMORDER]" value="PRODUCT">
      <input type="hidden" class="uniqkey" name="properties[_CUSTOMORDER_KEY]" value="">`;
    optionList.forEach(function(option) {
      switch (option.type) {
        case "choices" :
          html += createChoices(option);
          break;
        case "select" :
          html += createDropDown(option);
          break;        
        case "checkbox" :
          html += createCheckBox(option);
          break;
        default:
          break;
      }
    });
    //選択しているオプションの金額を表示
    if(Shopify.currency.active === "JPY"){
      var moneyhtml = `<div class="CustomOrderTotal hideOption">
                <div>
                  Total Extras:
                  <span>&yen;2,500</span> 
                  (+tax)
                </div>
                </div>`;
    } else {
      var price = "2500";
      var money = formatPrice(price);
      console.log(money);
      var moneyhtml = `<div class="CustomOrderTotal hideOption">
                <div>
                  Total Extras:
                  <span>${money}</span> 
                </div>
                </div>`;
    }
    var customOrderOptionsElement = document.getElementById('customOrderOptions');
    var customOrderOptionsElement2 = document.getElementById('customOrderOptionsmoney');
    customOrderOptionsElement.insertAdjacentHTML('afterbegin', html);
    customOrderOptionsElement2.insertAdjacentHTML('afterbegin', moneyhtml);
    
  }
}

//オプションタイプ　選択肢
function createChoices(element) {
  var html = ``;
  var choiseHtml = ``;
  html = `<div class="customOrderOption2">
            <div class="customOrderOptionTitle">${element.name}*</div>
            <div class="customOrderOptionElement choices">
            <input type="hidden" class="syuriumu" name="properties[_${window.customOrderEscapeHtmlAttribute(element.name)}]" value="">`;
  element.choices.forEach(function(choice) {
    console.log(Number(choice.price.amount));
    var pricenote = "";
    if(choice.price.amount !== "0"){
      pricenote = formatPrice(Number(choice.price.amount));
    }
    console.log(pricenote);
    var variantId = String(choice.price.variant_id).replace("gid://shopify/ProductVariant/", "");
    choiseHtml += `<div class="customOrderOptionValue">`
    choiseHtml +=   `<input type="radio" onclick="checkRadio();" class="${window.customOrderEscapeHtmlAttribute(choice.id)}" id="${window.customOrderEscapeHtmlAttribute(choice.value)}" name="properties[${window.customOrderEscapeHtmlAttribute(element.name)}]" value="${window.customOrderEscapeHtmlAttribute(choice.value)}">
                     <span class="choiseValue">${choice.value}</span>
                     <span class="choiseNote">${pricenote}</span>`
    choiseHtml += `</div>`;
    
  });
  html += choiseHtml;
  html += `  </div>
           </div>`;
  return html;
  
}

//オプションタイプ　ドロップダウン
function createDropDown(element) {
  dropDownCount++;
  var html = ``;
  var dropDownHtml = ``;
  var sizeCount = 0;
  var sodetakeSize = defaultSize;
  
  html = `<div class="customOrderOption2 hideOption">
            <div class="customOrderOptionTitle">${element.name}</div>
            <div class="customOrderOptionElement dropdownCustom">
              <select name="properties[${window.customOrderEscapeHtmlAttribute(element.name)}]" class="customOrderOptionValue" id="select${dropDownCount}">
                <option  value="">-- Choose ${element.name} --</option>`;
  element.choices.forEach(function(dropDown) {
    dropDownHtml += `<option value="${window.customOrderEscapeHtmlAttribute(dropDown.value)}">${sodetakeSize} cm（詰め寸法: ${dropDown.value} cm）</option>`;
    if(sizeCount === 0) {
      sodetakeSize--;
      sizeCount++;
    }else {
      sodetakeSize = sodetakeSize - 0.5;
      sizeCount++;
    }
  });
  html += dropDownHtml;
  html += `  </select>  
            </div>
            <span class="customorderError"><small>必須項目のため、選択してください / This option is required.</small></span>
           </div>`;
  if(dropDownCount === dropDownCountLimit) {
    html += `<span class="customHelpText hideOption"><small>${dropDownMessage}</small></span>`;
  }
  return html;
}

//オプションタイプ　チェックボックス
function createCheckBox(element) {
  checkBoxCount++;
  var html = ``;
  html = `<div class="customOrderOption2 hideOption">
            <div class="customOrderOptionTitle">${element.name}</div>
            <div class="customOrderOptionElement checkBoxCustom">
              <input type="checkbox" class="${window.customOrderEscapeHtmlAttribute(element.name)}" id="checkBox${checkBoxCount}" name="properties[${window.customOrderEscapeHtmlAttribute(element.name)}]" value="${window.customOrderEscapeHtmlAttribute(element.note)}">
              <input type="hidden" class="${window.customOrderEscapeHtmlAttribute(element.name)}" name="${window.customOrderEscapeHtmlAttribute(element.name)}">
              <span class="checkboxTitle">${element.note}</span>
            </div>
            <span class="customorderError"><small>必須項目のため、選択してください / This option is required.</small></span> 
          </div>`;

  if(checkBoxCount === checkBoxCountLimit) {
    html += `<span class="customHelpText hideOption"><small>${checkBoxMessage}</small></span>`;
  }
  
  return html;
}

//ページ読込み時初期処理
var loadPageInterval = setInterval(() => {
  var defaultClicker = document.getElementById( "修理有り" );
  var selectSize = document.getElementsByClassName("single-option-selector")[0];
  
  if(defaultClicker !== null) {
    document.getElementById( "修理有り" ).click();

    $('.size-swacth-element').on('click', function() {
      changeSodetake($('input[class=size-swacth-element]:checked').val());
    });
    changeSodetake($('input[class=size-swacth-element]:checked').val());
    clearInterval(loadPageInterval);
  }
  
},500)

//ベースサイズと対応する標準サイズの取得
function getSize(){
  // var sizeObj = document.getElementsByClassName("single-option-selector")[0];

  // // sizeObj
  // var idx = sizeObj.selectedIndex;
  // // 値を取得
  // var Size  = sizeObj.options[idx].text;

  //デフォルトのサイズ取得
  return replaceBoldSizeData[`${$('input[class=size-swacth-element]:checked').val()}`];
  
}

//ベースサイズ変更時の袖丈数値の変更
function changeSodetake(value) {
  //ドロップダウン取得
  var selectRight = document.querySelector(`select[name='properties[仕上り寸法（右袖）/ 単位:cm*]']`).options;
  var selectLeft = document.querySelector(`select[name='properties[仕上り寸法（左袖）/ 単位:cm*]']`).options;
  //ベースサイズに合わせて袖丈サイズを変更
  var sizeCount = 0;
  var sodetakeSize = replaceBoldSizeData[`${value}`];;

  selectRight.forEach((option,index) => {
    if(index === 0) {return;}
    option.innerHTML = `${sodetakeSize} cm（詰め寸法: ${option.value} cm）`;
    if(sizeCount === 0) {
      sodetakeSize--;
      sizeCount++;
    }else {
      sodetakeSize = sodetakeSize - 0.5;
      sizeCount++;
    }
  });

  var sizeCount2 = 0;
  var sodetakeSize2 = replaceBoldSizeData[`${value}`];

  selectLeft.forEach((option2,index) => {
    if(index === 0) {return;}
    option2.innerHTML = `${sodetakeSize2} cm（詰め寸法: ${option2.value} cm）`;
    if(sizeCount2 === 0) {
      sodetakeSize2--;
      sizeCount2++;
    }else {
      sodetakeSize2 = sodetakeSize2 - 0.5;
      sizeCount2++;
    }
  })
  

  
}

function formatPrice(amount) {
  
  const productPrice = amount; // 日本円での価格
  let currencyRate = Number(Shopify.currency.rate); // 為替レート（例: 0.0062406864）
  const currencyRateHalfup = currencyRate.toPrecision(3);

  const feePercentage = 0.015; // 両替手数料（1.5%）
  const roundingIncrement = 0.05; // 端数処理ルール（例: 0.05ドル単位で切り上げ）

  const finalPrice = this.formatConvertedPrice(
    productPrice,
    currencyRateHalfup,
    amount
  );
  return finalPrice;
}
function convertPriceWithRounding(productPrice, currencyRate) {
  // 1. 両替レートを適用
  let convertedPrice = productPrice * currencyRate;
  // console.log(productPrice);
  // console.log(currencyRate);
  // console.log(convertedPrice);

  let roundedPrice = (Math.round(convertedPrice * 100) / 100).toFixed(2);

  return roundedPrice;
}
function formatConvertedPrice(productPrice, currencyRate, amount) {
  // 金額を変換
  const currencyFormatters = {
    USD: new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }),
    JPY: new Intl.NumberFormat("ja-JP", { style: "currency", currency: "JPY" }),
    EUR: new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }),
    GBP: new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }),
    AUD: new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }),
    CAD: new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" }),
    CNY: new Intl.NumberFormat("zh-CN", { style: "currency", currency: "CNY" }), // 中国元
    TWD: new Intl.NumberFormat("zh-TW", { style: "currency", currency: "TWD" }), // 台湾ドル
    KRW: new Intl.NumberFormat("ko-KR", { style: "currency", currency: "KRW" }), // 韓国ウォン
    THB: new Intl.NumberFormat("th-TH", { style: "currency", currency: "THB" }), // タイバーツ
    SGD: new Intl.NumberFormat("en-SG", { style: "currency", currency: "SGD" }), // シンガポールドル
    IDR: new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR" }), // インドネシアルピア
  };
  const convertedPrice = this.convertPriceWithRounding(
    productPrice,
    currencyRate
  );

  console.log(convertedPrice);

  // フォーマットを適用
  const formatter =
    currencyFormatters[Shopify.currency.active] || new Intl.NumberFormat();
  return formatter.format(Number(convertedPrice));
}

